class SvgMap {
    constructor(selector) {
        this.svg = document.querySelector(selector);
        this.points = [];
        this.init();
    }

    init() {
        if (!this.svg) {
            /* console.error('SVG haritası bulunamadı'); */
            return;
        }

        // SVG'yi içeriğe göre boyutlandır
        this.fitSvgToContent();
        
        /* this.createPoints(); */
        this.addEventListeners();
    }

 /*    createPoints() {
        // data-name özelliği olan path'leri bul
        const pathsWithName = this.svg.querySelectorAll('path[data-name]');
        
        pathsWithName.forEach(path => {
            if(path.getAttribute('data-clickable') !== 'true'){
                return;
            }
            const name = path.getAttribute('data-name');
            const point = this.createPoint(path, name);
            this.points.push(point);
            
            // Path hover event'leri ekle
            this.addPathHoverEvents(path, point);
        });
    } */

 /*   createPoint(path, name) {
       // Path'in dolu alanında güvenli bir nokta bul
        const bbox = path.getBBox();
       const anchor = this.findPointInsidePath(path, bbox);
       const centerX = anchor.x;
       const centerY = anchor.y;

        // Nokta elementi oluştur
        const point = document.createElementNS('http://www.w3.org/2000/svg', 'g');
        point.setAttribute('class', 'map-point');
        point.setAttribute('data-name', name);

        // Nokta çemberi - CSS stillerine göre ayarlandı
        const circle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
        circle.setAttribute('cx', centerX);
        circle.setAttribute('cy', centerY);
        circle.setAttribute('r', '5'); // 10px width/height için radius 5
        circle.setAttribute('class', 'point-circle');
        circle.setAttribute('fill', '#000'); // background: #000
        circle.setAttribute('stroke', '#FFF'); // border: 1px solid #FFF
        circle.setAttribute('stroke-width', '1.6');

        // İsim metni - CSS stilleri için foreignObject kullan
        // Metin uzunluğuna göre dinamik boyutlar
        const textLength = name.length;
        const textWidth = Math.max(80, Math.min(textLength * 11, 160)); // Dinamik genişlik
        const textHeight = 25; // Sabit yükseklik
        
        // Point'in üst kenarından sabit mesafe hesapla
        const pointTop = centerY - 5; // Point'in üst kenarı (centerY - radius)
        const textY = pointTop - 15; // Point'in üst kenarından 15px yukarı
        
        const foreignObject = document.createElementNS('http://www.w3.org/2000/svg', 'foreignObject');
        foreignObject.setAttribute('x', centerX - 0);
        foreignObject.setAttribute('y', textY - 12);
        foreignObject.setAttribute('width', textWidth);
        foreignObject.setAttribute('height', textHeight);
        
        const textDiv = document.createElement('div');
        textDiv.className = 'point-text';
        textDiv.textContent = name;
        textDiv.style.textAlign = 'center';
        textDiv.style.width = '100%';
        textDiv.style.height = '100%';
        textDiv.style.display = 'flex';
        textDiv.style.alignItems = 'center';
        textDiv.style.justifyContent = 'center';
        textDiv.style.opacity = '0'; // Başlangıçta gizli
        textDiv.style.transition = 'opacity 0.3s ease'; // Smooth geçiş
        
        foreignObject.appendChild(textDiv);

        // Nokta ve metni gruba ekle
        point.appendChild(circle);
        point.appendChild(foreignObject);

        // Point'i başlangıçta gizli yap
        point.style.opacity = '0';
        point.style.transition = 'opacity 0.3s ease';

        // SVG'ye ekle
        this.svg.appendChild(point);

        return {
            element: point,
            name: name,
            path: path,
            centerX: centerX,
            centerY: centerY
        };
    }  */

   /*  findPointInsidePath(path, bbox) {
        const centerX = bbox.x + (bbox.width / 2);
        const centerY = bbox.y + (bbox.height / 2);

        if (this.isPointInsidePath(path, centerX, centerY)) {
            return { x: centerX, y: centerY };
        }

        // Merkez boşlukta kalıyorsa spiral arama ile dolu alanda en yakın noktayı bul.
        const maxRadius = Math.max(bbox.width, bbox.height);
        const radiusStep = 2;
        const angleStep = 12;

        for (let radius = radiusStep; radius <= maxRadius; radius += radiusStep) {
            for (let angle = -90; angle < 270; angle += angleStep) {
                const rad = angle * (Math.PI / 180);
                const x = centerX + (Math.cos(rad) * radius);
                const y = centerY + (Math.sin(rad) * radius);

                if (this.isPointInsidePath(path, x, y)) {
                    return { x, y };
                }
            }
        }

        // Son çare: bbox içinden tarama yap.
        let best = null;
        const gridStep = 6;
        for (let y = bbox.y; y <= bbox.y + bbox.height; y += gridStep) {
            for (let x = bbox.x; x <= bbox.x + bbox.width; x += gridStep) {
                if (!this.isPointInsidePath(path, x, y)) {
                    continue;
                }

                const dx = x - centerX;
                const dy = y - centerY;
                const score = (dx * dx) + (dy * dy) + (dy * 0.2);

                if (!best || score < best.score) {
                    best = { x, y, score };
                }
            }
        }

        if (best) {
            return { x: best.x, y: best.y };
        }

        return { x: centerX, y: centerY };
    } */

    isPointInsidePath(path, x, y) {
        if (!this.svg || typeof path.isPointInFill !== 'function') {
            return false;
        }

        const svgPoint = this.svg.createSVGPoint();
        svgPoint.x = x;
        svgPoint.y = y;

        try {
            return path.isPointInFill(svgPoint);
        } catch (e) {
            return false;
        }
    }

    addEventListeners() {
        this.points.forEach(point => {
            const circle = point.element.querySelector('.point-circle');
            // Tıklama efekti
            /* circle.addEventListener('click', () => {
                this.handlePointClick(point);
            }); */

            // Point hover event'leri ekle
            this.addPointHoverEvents(point);
        });
    }

    addPathHoverEvents(path, point) {
        const textDiv = point.element.querySelector('.point-text');
        point.element.style.opacity = '1';
        if (textDiv) {
            textDiv.style.opacity = '1';
        }
        // Path hover olduğunda point ve text'i göster
        /* path.addEventListener('mouseenter', () => {
            point.element.style.opacity = '1';
            if (textDiv) {
                textDiv.style.opacity = '1';
            }
        }); */
        
        // Path'den çıkıldığında point ve text'i gizle
        /* path.addEventListener('mouseleave', () => {
            // Point'in üzerinde değilse gizle
            if (!point.element.matches(':hover')) {
                point.element.style.opacity = '0';
                if (textDiv) {
                    textDiv.style.opacity = '0';
                }
            }
        }); */
    }

    addPointHoverEvents(point) {
        const textDiv = point.element.querySelector('.point-text');
        
        // Point hover olduğunda text'i göster (point zaten görünür)
        point.element.addEventListener('mouseenter', () => {
            if (textDiv) {
                textDiv.style.opacity = '1';
            }
        });
        
        // Point'den çıkıldığında text'i gizle
        /* point.element.addEventListener('mouseleave', () => {
            if (textDiv) {
                textDiv.style.opacity = '0';
            }
            // Point'i de gizle
            point.element.style.opacity = '0';
        }); */
    }

    fitSvgToContent() {
        // G elementini bul
        const gElement = this.svg.querySelector('#svg-map-turkey-g');
        if (!gElement) {
            /* console.error('SVG g elementi bulunamadı'); */
            return;
        }

        // G elementinin bounding box'ını hesapla
        const bbox = gElement.getBBox();
        
        // Padding ekle (kenarlardan boşluk)
        const padding = 20;
        const x = bbox.x - padding;
        const y = bbox.y - padding;
        const width = bbox.width + (padding * 2);
        const height = bbox.height + (padding * 2);

        // SVG'nin viewBox'ını güncelle
        this.svg.setAttribute('viewBox', `${x} ${y} ${width} ${height}`);
        
        // console.log('SVG viewBox güncellendi:', `${x} ${y} ${width} ${height}`);
    }

    // highlightPoint(point) {
    //     const circle = point.element.querySelector('.point-circle');
    //     const textDiv = point.element.querySelector('.point-text');
        
    //     // Nokta büyütme animasyonu
    //     circle.setAttribute('r', '7');
    //     circle.setAttribute('fill', '#333');
        
    //     // Metin vurgulama - CSS ile yapılacak
    //     if (textDiv) {
    //         textDiv.style.background = 'rgba(231, 76, 60, 0.9)';
    //         textDiv.style.transform = 'scale(1.1)';
    //     }
        
    //     // Path'i vurgula
    //     if (point.path) {
    //         point.path.style.fill = '#f39c12';
    //         point.path.style.opacity = '0.8';
    //     }
    // }



    handlePointClick(point) {

        /* console.log(`${point.name} şehrine tıklandı!`);
        
        // Tıklama animasyonu
        const circle = point.element.querySelector('.point-circle');
        circle.setAttribute('r', '8');
        
        setTimeout(() => {
            circle.setAttribute('r', '5');
        }, 200);

        // Burada şehir detayları için modal açılabilir veya sayfa yönlendirmesi yapılabilir
        this.showCityDetails(point.name); */
    }

    showCityDetails(cityName) {
        // Şehir detaylarını göstermek için modal veya başka bir UI elementi
        // Bu kısmı projenizin ihtiyaçlarına göre özelleştirebilirsiniz
        alert(`${cityName} şehri seçildi!`);
    }

    // Noktaları gizle/göster
    togglePoints(show = true) {
        this.points.forEach(point => {
            point.element.style.display = show ? 'block' : 'none';
        });
    }

    // Belirli bir şehri vurgula
    highlightCity(cityName) {
        const point = this.points.find(p => p.name === cityName);
        if (point) {
            // this.highlightPoint(point);
        }
    }


}

// Global olarak erişilebilir yap
window.SvgMap = SvgMap;

export default SvgMap;
